/*
 * Listener for the controls in contact page sidebar toggle
 */
(function($){
    var sidebar_links = $('.sidebar_contact a');
    //don't need to toggle if there are 1 or less links
    if(sidebar_links.length < 2){
        sidebar_links.on('click', function(event) {
            event.preventDefault();
        });
        return;
    }
    sidebar_links.on('click', function(event) {
        event.preventDefault();
        var clicked = $(this);
        var sidebar_list = clicked.closest('.sidebar_contact').find('li');
        $('.sidebar_contact li').removeClass('current_page_item');
        var parent = clicked.closest('li');
        // parent.addClass('current_page_item');
        var currentIndex = sidebar_list.index(parent);
        $('.sidebar_contact li:nth-of-type(' + (currentIndex + 1)  +')').addClass('current_page_item');
        $('.contact-page').find('.page_item').addClass('sm_hide');
        $('.sidebar_contact').find('.current_page_item').removeClass('sm_hide');
        var currentLocationInfo = $('#contact_info').data('contact-infos')[currentIndex];
        display_contact_info(currentLocationInfo);
    });

    var display_contact_info = function(contact_info){
        var get = function(id){return document.getElementById(id); };
        get('contact_map').innerHTML = contact_info.map;
        get('contact_address').innerHTML = address_info(contact_info);
        get('contact_phone').innerHTML = phone_info(contact_info);
        get('contact_email').innerHTML = email_info(contact_info);
        $('.contact_box').each(function(index, el) {
            var current_box = $(this);
            if(current_box.text() === ''){
                current_box.hide();
            }
            else{
                current_box.show();
            }
        });
    };

    var address_info = function(contact_info){
        var info_string = '<span class="contact_factoid_heading">';
        info_string += '</span><span class="contact_factoid">';
        if(contact_info['address1']){
            info_string += contact_info['address1']+'<br/>';
        }
        if(contact_info['address2']){
            info_string += contact_info['address2']+'<br/>';
        }
        if(contact_info['city']){
            info_string += contact_info['city']+',&nbsp;';
        }
        if(contact_info['state']){
            info_string += contact_info['state']+'&nbsp;';
        }
        info_string += contact_info['zip'];
        info_string += '</span>';
        return info_string
    }

    var phone_info = function(contact_info){
        var info_string = '<span class="contact_factoid_heading">';
        if(contact_info['office'] || contact_info['mobile'] || contact_info['fax']){
            info_string += 'PHONE:';
        }
        info_string += '</span><span class="contact_factoid">';
        if(contact_info['office']){
            info_string += contact_info['office']+'<br/>';
        }
        if(contact_info['mobile']){
            info_string += contact_info['mobile']+'<br/>';
        }
        if(contact_info['fax']){
            info_string += contact_info['fax'];
        }
        info_string += '</span>';
        return info_string;
    };
    var email_info = function(contact_info){
        var info_string = '<span class="contact_factoid_heading">';
        if(contact_info['email']){
            info_string += "EMAIL:";
        } 
        info_string += '</span><span class="contact_factoid">';
        info_string += contact_info['email']+'</span>';
        return info_string;
    };
    
})(jQuery);